import { render, staticRenderFns } from "./Popout.vue?vue&type=template&id=671f4a64&"
import script from "./Popout.vue?vue&type=script&lang=ts&"
export * from "./Popout.vue?vue&type=script&lang=ts&"
import style0 from "./Popout.vue?vue&type=style&index=0&id=671f4a64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports